import moment from "moment";
import { getAdoptionAnalysisAction } from "../../../../redux/actions/NetworkIntelligenceAction";

export const initialStateAdoption = {
  page: 1,
  rows: 10,
  sortDirection: "desc",
  sortColumn: null,
  ProviderIds: null,
  startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
  endDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
  BusinessType: null,
  VisitType: null,
  Source: "AdoptionAnalysis",
  providerType:false
};
export const initialExcelStateAdoption = {
  page: 1,
  rows: 0,
  sortDirection: "desc",
  providerIds: "",
  startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
  endDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
  sortColumn: "",
  BusinessType: null,
  VisitType: null,
  Source: "Export",
};

export const callAdoptionAnalysisAction = (dispatch, data) => {
  dispatch(getAdoptionAnalysisAction(data));
};

export const tableHeaderAnalysis = [
  {
    name: "Provider ID",
  },
  {
    name: "Provider Name",
  },
  {
    name: "Total Appoinment",
  },
  {
    name: "Accept/Reject",
  },
  {
    name: "Show/NoShow",
  },
  {
    name: "Report Upload",
  },
  {
    name: "Report On Hold",
  },
];

export const AdoptionFunnelBox = [
  {
    heading: "Providers",
    key: "totalProvider",
    percentSign: false,
    imgSrc: "../images/provider.png",
  },
  {
    heading: "Appointments",
    key: "totalAppointment",
    percentSign: false,
    imgSrc: "../images/provider.png",
  },
  {
    heading: "Accept/Reject",
    key: "acceptRejectPercent",
    percentSign: true,
    imgSrc: "../images/accept-reject.png",
  },
  {
    heading: "Show/NoShow",
    key: "showNoShowPercent",
    percentSign: true,
    imgSrc: "../images/shownoshow.png",
  },
  {
    heading: "Report Upload",
    key: "reportUploadPercent",
    percentSign: true,
    imgSrc: "../images/file_upload.png",
  },
  {
    heading: "Report On Hold",
    key: "reportOnHoldPercentage",
    percentSign: true,
    imgSrc: "../images/file_upload.png",
  },
];
